export const INTERVIEW_SCHEDULE_PERMISSION_CODES = {
    WEB_RECRUITMENT_INTERVIEW_SCHEDULE_LIST: 'WEB_RECRUITMENT_INTERVIEW_SCHEDULE_LIST',
    WEB_RECRUITMENT_INTERVIEW_SCHEDULE_DETAIL: 'WEB_RECRUITMENT_INTERVIEW_SCHEDULE_DETAIL',
    WEB_RECRUITMENT_INTERVIEW_SCHEDULE_ADD: 'WEB_RECRUITMENT_INTERVIEW_SCHEDULE_ADD',
    WEB_RECRUITMENT_INTERVIEW_SCHEDULE_EDIT: 'WEB_RECRUITMENT_INTERVIEW_SCHEDULE_EDIT',
    WEB_RECRUITMENT_INTERVIEW_SCHEDULE_DELETE: 'WEB_RECRUITMENT_INTERVIEW_SCHEDULE_DELETE',
    WEB_RECRUITMENT_INTERVIEW_SCHEDULE_IMPORT: 'WEB_RECRUITMENT_INTERVIEW_SCHEDULE_IMPORT',
    WEB_RECRUITMENT_INTERVIEW_SCHEDULE_EXPORT: 'WEB_RECRUITMENT_INTERVIEW_SCHEDULE_EXPORT',
} as const;

